<template>
  <v-app id="inspire">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 style="max-width: 1020px; max-height: 600px">
            <v-card class="elevation-0 card">
              <img
                style="width: 100%; height: 100%"
                src="../assets/logoCa.jpg"
              />
              <v-form style="padding: 5px 5px 5px 5px">
                <label style="font-weight: Bold; color: #05523e">ID</label>
                <input
                  placeholder="Id"
                  v-model="id"
                  @input="changeInput()"
                  @keyup.enter="validation()"
                />
                <p style="color: red; margin: 3px 0 5px 7px; font-size: 13px">
                  {{ this.idError }}
                </p>
                <label style="font-weight: Bold; color: #05523e"
                  >PASSWORD</label
                >
                <input
                  placeholder="Password"
                  @input="changeInput()"
                  type="password"
                  v-model="password"
                  @keyup.enter="validation()"
                />
                <p style="color: red; margin: 3px 0 5px 7px; font-size: 13px">
                  {{ this.pwError }}
                </p>

                <v-btn
                  class="white--text elevation-5 rounded-lg buttons"
                  color="#05523E"
                  style="width: 100%; height: 50px; margin-top: 5px"
                  @click="validation()"
                  >LOG IN</v-btn
                >
                <v-btn
                  fontColor
                  class="grey--text text--darken-1 elevation-0 buttons"
                  color="#ffffff"
                  style="width: 100%; height: 50px"
                  @click="forgotAccount()"
                  >FORGOT ID OR PASSWORD</v-btn
                >
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { runGqlMutation } from "@/graphql/gqlUtil.js";
import { LOGIN } from "@/graphql/AccountMutations.js";

export default {
  data() {
    return {
      id: "",
      password: "",
      idError: "",
      pwError: "",
    };
  },
  methods: {
    async changeInput() {
      if (this.id.length === 0) {
        this.idError = "required";
      } else {
        this.idError = "";
      }
      if (this.password.length === 0) {
        this.pwError = "required";
      } else {
        this.pwError = "";
      }
    },
    async validation() {
      if (this.id.length === 0 || this.password.length === 0) {
        this.idError = "required";
        this.pwError = "required";
        return;
      }

      this.idError = "";
      this.pwError = "";
      this.login();
    },
    async login() {
      try {
        const result = await runGqlMutation(LOGIN, {
          id: this.id,
          password: this.password,
        });

        if (result.message === undefined && result.login.Token) {
          this.idError = "";
          this.pwError = "";
          await localStorage.setItem("token", result.login.Token);
          await localStorage.setItem("admin", result.login.Admin.Permission);

          if (result.login.Admin.Permission) {
            // master
            this.$router.push({ name: "Dashboard" });
          } else {
            // admin
            this.$router.push({ name: "Orders" });
          }
        } else {
          this.$store.commit("common/snackErrOn", {
            text: "Please check your ID and password.",
          });
        }
      } catch (err) {
        console.error("login: " + err);
      }
    },
    async forgotAccount() {
      try {
        this.$router.push({ name: "ForgotAccounts" });
      } catch (err) {
        console.error("forgotAccount: " + err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  height: 50px !important;
  padding-left: 10px;
  border: 1px solid #cccccc;
  height: 30px;
  width: 100%;
  border-radius: 5px;
  margin: 5px auto 5px;
}
</style>
